const de = {
  heroTitle: "Bovan-See",
  home: 'Startseite',
  contact: 'Kontakt',
  apartments: 'Apartments',
  about: 'Über den Bovan-See',
  more: 'Mehr',
  button: 'Jetzt buchen',
  aboutHeader: 'Bovan-See - Verborgener Schatz von Ostserbien',
  aboutFirstTitle: 'Bovan-See - Oase des Friedens und der natürlichen Schönheit',
  aboutFirstSlide: 'Der Bovan-See, verborgen im Herzen Serbiens, ist eine wahre Oase des Friedens und der natürlichen Schönheit. Er liegt zwischen Aleksinac und Sokobanja und zieht mit seinem kristallklaren Wasser und unberührter Natur die Aufmerksamkeit auf sich. Er ist ideal für diejenigen, die dem hektischen Stadtleben entfliehen und Frieden in der Natur finden möchten.',
  aboutSecondTitle: 'Künstlicher See mit natürlicher Schönheit',
  aboutSecondSlide: 'Obwohl es sich um einen künstlichen See handelt, der 1978 durch den Bau eines Damms am Fluss Moravica entstand, kann er als natürliche Schönheit von Ostserbien bezeichnet werden. Er ist etwa acht Kilometer lang, sodass er für diejenigen, die sich keinen Meerurlaub leisten können, eine geeignete Alternative darstellt. Der Damm wurde gebaut, um Überschwemmungen zu verhindern, aber der im Laufe der Zeit entstandene See hat sich zu einem Zentrum für Erholung und Tourismus entwickelt.',
  aboutThirdTitle: 'Erholung und Abenteuer am See',
  aboutThirdSlide: 'Wenn man den Bovan-See zum ersten Mal sieht, fällt einem sofort die unglaubliche Farbe des Wassers auf, die je nach Licht und Jahreszeit von smaragdgrün bis tiefblau variiert. Umgeben von bewaldeten Hügeln und üppiger Vegetation bietet der See zahlreiche Möglichkeiten für Erholung und Abenteuer wie Angeln, Schwimmen, Segeln, Kajakfahren und Radfahren.',
  aboutFourthTitle: 'Lokale Spezialitäten und Naturgenuss',
  aboutFourthSlide: 'Ein Besuch am Bovan-See ist nicht komplett, ohne die lokalen Spezialitäten zu probieren. In den nahegelegenen Dörfern kann man hausgemachte Produkte wie Käse, Honig und Brandy genießen. Restaurants in der Umgebung bieten traditionelle Gerichte wie Lamm, das unter einer Glocke gegart wird, und verschiedene Arten von Forellen an. Dies ist das perfekte Ziel für eine Kombination aus Abenteuer, Entspannung und natürlicher Schönheit.',
  apartmentFeature: "Merkmal",
  apartmentFrom: "ab",
  apartmentPrice: "pro Nacht",
  reccomendedTitle: "Empfohlene Apartments",
  reccomendedDescription: "Entdecken Sie unser sorgfältig ausgewähltes Sortiment an atemberaubenden Apartments am See, die jedes eine einzigartige Erfahrung und atemberaubende Ausblicke bieten.",
  commonQuestionTitle: "Häufig gestellte Fragen",
  testimonialsTitle: "Was unsere Gäste sagen",
  contactTitle: "Kontaktieren Sie uns",
  contactSecondTitle: "Genießen Sie die Ruhe und Schönheit des Bovan-Sees. Die Bella Apartments bieten eine perfekte Kombination aus Komfort und natürlicher Umgebung für einen erholsamen Urlaub. Jetzt buchen!",
  contactName: "Name",
  contactMessage: "Nachricht",
  contactSuccess: "Nachricht erfolgreich gesendet!",
  contactFail: "Beim Senden Ihrer Nachricht ist ein Fehler aufgetreten.",
  contactSending: "Wird gesendet...",
  contactSend: "Nachricht senden",
  contactInformation: "Kontaktinformationen",
  footerDescription: "Moderne Apartments am Bovansee, in ruhiger Lage mit wunderschönem Blick auf den See. Familienfreundliche Ausstattung wie ein großer Garten, Liegestühle, Kajak, Boot, Grill und vieles mehr für einen entspannten Aufenthalt.",
  footerFirstTitle: "ÜBER",
  footerSecondTitle: "KONTAKTINFORMATIONEN",
  footerThirdTitle: "SCHNELLE LINKS",
  welcomeTitle: "Willkommen im Seeleben",
  welcomeDescription: "Entdecken Sie die perfekte Kombination aus Luxus und Natur in unseren Apartments am See, wo jeder Sonnenaufgang neue Möglichkeiten für das Leben am See bringt.",
  section1Title: "Bovan-See: Oase des Friedens und der natürlichen Schönheit",
  section1Description: "Versteckt im Herzen Serbiens ist der Bovan-See der ideale Ort, um dem Stadtleben zu entfliehen, mit kristallklarem Wasser und unberührter Natur.",
  feature1Title: "Ursprung und Geschichte",
  feature1Description: "Ein künstlicher See, der 1978 durch den Bau eines Damms am Fluss Moravica entstanden ist, ist acht Kilometer lang und bietet sowohl Erholung als auch natürliche Schönheit in Ostserbien.",
  feature2Title: "Wasserfarbe und Wälder",
  feature2Description: "Die unglaubliche Wasserfarbe, die von smaragdgrün bis tiefblau reicht, und die dichten Wälder schaffen die perfekte Umgebung für Genuss.",
  feature3Title: "Freizeitaktivitäten",
  feature3Description: "Angeln, Schwimmen, Segeln, Kajakfahren und Pedalbootfahren sind nur einige der Aktivitäten, die der See bietet.",
  feature4Title: "Orte und Sehenswürdigkeiten in der Nähe",
  feature4Description: "Sokobanja ist 17 km von Bella Apartments entfernt.\nBella Apartments sind 48 km vom Flughafen Niš entfernt.",
  
  feature5Title: "Ausflugsziele",
  feature5Description: "Lepterija und Soko Grad\nRipaljka Wasserfall\nQuelle des Moravica Flusses\nVrmdzansko See\nRestaurant 'Etno Vodenica bei Großvater Mija'\nSesalačka Höhle\nBorici Park\nBadestrände am Moravica Fluss\n'Dzentlmen' Strand",
  
  feature6Title: "Restaurants in Sokobanja",
  feature6Description: "Zelengora\nRestaurant Stanković\nPizzeria Lav\nLa Famiglia Sokobanja\nRestaurant Župan\nRestaurant Milošev Konak\n️Restaurant Stara Vodenica\n️Kafana Kod Kuma\n️Kod Pudle\n️Vodenica bei Großvater Mija\n️Filotin Aussicht",
  section2Title: "Strände und Umgebung",
  section2Description: "Klarer Strände, gepflegt von den Einheimischen, bieten eine einzigartige Umgebung zur Entspannung.",
  excellenceTitle: "Lokale Gastronomie",
  excellenceDescription: "Traditionelle Gerichte und hausgemachte Produkte wie Käse, Honig und Brandy machen einen Besuch am Bovan-See unvergesslich.",
  holidayPeriod: "Urlaubszeitraum",
  regularPeriod: "In der Saison",
  nonRegularPeriod: "Außerhalb der Saison",
  holidayDates: ["30.12 - 02.01" , "01.05" , "14.02" , "11.11"], 
  holidayPrice: "€300",
  regularNightPrice: "€50",
  nonRegularNightPrice: "€40",
  weekendPrice: "€130",
  checkIn: "12:00 Check-in",
  checkOut: "15:00 Check-out",
  weekendTime: "Fr 14:00 - So 18:00",
  wifi: "Kostenloses WLAN",
  tv: "Satelliten-TV",
  bbq: "BBQ Verfügbar",
  beddingTowels: "Bettwäsche und Handtücher",
  parking: "Parkplatz",
  bathroomWithHairdryer: "Badezimmer mit Haartrockner",
  spaciousLiving: "Geräumiges Wohnzimmer",
  max4Adults: "Maximal 4 Erwachsene",
  lakeView: "Seeansicht",
  completeKitchen: "Vollständige Küche",
  spaciousTerrace: "Geräumige Terrasse",
  noParties: "Keine Partys",
  noPets: "Keine Haustiere",
  twoBedrooms: "Zwei Schlafzimmer",
  groundFloorApartmentDescription: "Wohnzimmer mit Schlafsofa, Schlafzimmer mit Doppelbett, Badezimmer, Küche mit Bar und Terrasse mit Seeblick.",
  upperFloorApartmentDescription: "Zwei Schlafzimmer (Doppelbett + Einzelbett), Badezimmer, Küche und Terrasse mit Seeblick.",
  firstTestimonialName: "Sara",
  firstTestimonialImage: "first",
  firstTestimonialText: "Ein schöner Aufenthalt am Bovan-See, die Apartments sind komfortabel und ruhig.",

  secondTestimonialName: "Mihajlo",
  secondTestimonialImage: "second",
  secondTestimonialText: "Der perfekte Ort für Entspannung, nahe der Natur und dem See.",

  thirdTestimonialName: "Marija",
  thirdTestimonialImage: "third",
  thirdTestimonialText: "Ich empfehle es für einen ruhigen und komfortablen Aufenthalt in schöner Natur.",

  fourthTestimonialName: "Danilo",
  fourthTestimonialImage: "fourth",
  fourthTestimonialText: "Der perfekte Ort für einen Familienurlaub, in der Nähe des Sees und der Natur.",
  amenities: "Hervorgehobene Annehmlichkeiten",
  aboutProperty: "Über diese Unterkunft",
  groundFloorApartmentTitle: "App Bella Erdgeschoss",
  upperFloorApartmentTitle: "App Bella Im Ersten Stock"
};

export default de;
